import { render, staticRenderFns } from "./GTMDemoContainer.vue?vue&type=template&id=793b2820&scoped=true"
import script from "./GTMDemoContainer.vue?vue&type=script&lang=js"
export * from "./GTMDemoContainer.vue?vue&type=script&lang=js"
import style0 from "./GTMDemoContainer.vue?vue&type=style&index=0&id=793b2820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793b2820",
  null
  
)

export default component.exports